import { types as users } from '../actions/users'
import { actions as profiles } from '../actions/profiles'
import { actions as settings } from '../actions/settings'

import { defaultLanguage } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { defaultTimezone } from '../../helpers/timezones'
import cookie from 'react-cookies'

// When the therapist logs in, the scanner performs a background scan on them (i.e. fetches their profile).
const scanner = (store) => {
    return (next) => {
        return (action) => {
            next(action)
            if (action.type === users.SET_USER_TOKENS) {
                console.log('action: ', action)
                const tokens = action.payload
                // eslint-disable-next-line no-console
                console.log('Scan therapist.')
                send({
                    method: 'GET',
                    tokens,
                    url: '/therapist'
                })
                    .then((response) => {
                        // eslint-disable-next-line no-console
                        console.log('Scanned therapist.')
                        const data = response.data
                        const language = data.language || defaultLanguage
                        const timezone = data.timezone || defaultTimezone
                        store.dispatch(settings.setLanguage(cookie.load('language')))
                        store.dispatch(settings.setTimezone(timezone))
                        const profile = {
                            bio: data.bio || undefined,
                            education: data.education || '',
                            firstName: data.name || '',
                            lastName: data.surname || '',
                            phone: data.phone || '',
                            picture: data.img_url || '',
                            timezone,
                            language,
                            sessionLink: data.session_link
                        }
                        store.dispatch(profiles.setProfile(profile))
                    })
                    .catch((error) => {
                        // Failed to scan therapist.
                        // eslint-disable-next-line no-console
                        store.dispatch(settings.setTimezone('UTC'))
                        console.error('Failed to scan therapist.', error)
                    })
            }
        }
    }
}

export default scanner



// WEBPACK FOOTER //
// ./src/store/middlewares/scanner.js